// extracted by mini-css-extract-plugin
export default {"languageSelector":"TranslationContent__languageSelector-V8fE1","buttonWrapper":"TranslationContent__buttonWrapper-tZCqK","defaultButton":"TranslationContent__defaultButton-yZMmG"};